import type { SeriesData, SeriesRecord } from '@/components/Chart/types/chartData';
import type { TimeSeriesPoint } from '@/components/Chart/utils/buildChartLineSeries';

export const aggregateTimeSeriesPoints = (
  series: SeriesData,
  field: string,
  decimalPlaces: number,
  seriesDataAggregator: (tsData: SeriesRecord, decimalPlaces: number) => TimeSeriesPoint
) => {
  return (
    series[field]?.map(tsData => {
      return {
        ...seriesDataAggregator(tsData, decimalPlaces)
      };
    }) ?? []
  );
};
